import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section id="about" className="py-20 md:py-28 bg-warm-white px-6" data-id="element-13">
      <div className="max-w-[1100px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20" data-id="element-14">
        {/* Left Column - Bio & Image */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-15">
          <span className="text-copper font-bold text-sm tracking-wider uppercase mb-3 block" data-id="element-16">
            About
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-forest mb-6" data-id="element-17">
            Helping families build tax-free wealth and secure their financial
            future
          </h2>
          <p className="text-charcoal text-lg leading-relaxed mb-8" data-id="element-18">
            Xander Winther specializes in Indexed Universal Life (IUL)
            strategies that balance protection, growth potential, and tax
            advantages—so your money works as hard as you do.
          </p>

          <div className="relative" data-id="element-19">
            <img src="https://cdn.magicpatterns.com/uploads/fL8PoyMm2jBhW7DdxgnPjQ/Xander_Winther.webp" alt="Xander Winther, IUL Specialist" className="rounded-xl shadow-soft w-full max-w-md object-cover aspect-[4/5] bg-gray-100" data-id="element-20" />
            <div className="absolute -bottom-6 -right-6 w-24 h-24 bg-cream rounded-full -z-10 hidden md:block" data-id="element-21"></div>
          </div>
        </motion.div>

        {/* Right Column - Mission */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="flex flex-col justify-center" data-id="element-22">
          <div className="bg-white p-8 md:p-10 rounded-2xl shadow-soft border border-gray-50" data-id="element-23">
            <h3 className="text-2xl font-bold text-forest mb-6" data-id="element-24">Our Mission</h3>
            <p className="text-charcoal text-lg leading-relaxed" data-id="element-25">
              We believe everyone deserves access to the same wealth-compounding
              strategies used by financially-savvy families. Our focus on
              indexed universal life insurance allows us to help clients grow
              tax-advantaged cash value while protecting the people they love
              most.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}